import promotion from '@resources/js/components/promotion'
import { getBcomOrExpediaPartnerType } from '@resources/js/components/promotion/helpers/getPartnerType'
import Modal from '@resources/js/ui/Modal'
import { initShareBtn } from '@resources/js/helpers/initShareBtn'
import '@resources/js/analytics'

const partnerType = getBcomOrExpediaPartnerType()

promotion({
	links: {
		active: !!shared.options.dest_id,
		type: partnerType,
	},
	backbtn: {
		active: !!shared.options.bbcl && !!shared.options.dest_id,
		type: partnerType,
	},
	tab_change: {
		active: !!shared.options.dest_id,
		type: partnerType,
	},
	popup: {
		active: !!shared.options.dest_id,
		type: partnerType,
	},
})

// Social networks popup
new Modal('.js-networks-popup', { trigger: '.js-networks', lockScroll: false })

// Share button
const shareBtn = document.querySelector('.js-share-btn')
initShareBtn(shareBtn)
